import type { Clube } from './tipos';

/** Item da loja de WebCoins. O preço sai da conta (só o servidor mexe no saldo); o efeito vale para o clube do técnico. */
export interface ItemLoja {
  id: string;
  nome: string;
  descricao: string;
  /** WebCoins */
  preco: number;
  /** o que o item dá, em texto, para a vitrine */
  ganho: string;
  /** dinheiro que entra no caixa do clube e conta como receita de patrocínio */
  receita: number;
  /** bônus de força (fração, 0,2 = +20%) em todos os jogadores do clube na próxima partida dele, só nela */
  bonus?: number;
}

export const CATALOGO_LOJA: readonly ItemLoja[] = [
  {
    id: 'patrocinio-master',
    nome: 'Novo patrocínio master',
    descricao: 'Você assinou com um novo patrocinador master e ganhou um bônus em dinheiro.',
    preco: 100,
    ganho: '+ R$ 20 milhões nas receitas do clube',
    receita: 20_000_000,
  },
  {
    id: 'bicho',
    nome: 'Bicho',
    descricao: 'Você prometeu um bicho para os jogadores em caso de vitória no próximo jogo.',
    preco: 200,
    ganho: '+20% de força em todos os jogadores do time na próxima partida (só nela)',
    receita: 0,
    bonus: 0.2,
  },
];

export const itemDaLoja = (id: string): ItemLoja | undefined => CATALOGO_LOJA.find((i) => i.id === id);

/** Aplica o efeito de um item no clube (a cobrança em WebCoins é feita antes, no servidor). */
export function aplicarItemLoja(clube: Clube, item: ItemLoja): void {
  clube.caixa += item.receita;
  clube.balanco.patrocinio += item.receita;
  if (item.bonus) clube.bonusPartida = Math.max(clube.bonusPartida ?? 0, item.bonus);
}

/** O efeito do item já está valendo (o bônus de partida não acumula: só uma compra por jogo)? */
export function itemJaAtivo(clube: Clube, item: ItemLoja): boolean {
  return Boolean(item.bonus && (clube.bonusPartida ?? 0) >= item.bonus);
}